import log from 'loglevel'
import asynCMCall from '../../Action/ChangeCM/changeContractManager'
import pushGTMEvent from '../../util/helper/pushGTMEvent'

const configContents = ({ state: { langStrings, authorized }, dispatch }) => {
  return [
    {
      isTitle: true,
      description: langStrings
        ? langStrings.cm.authorizationRequestScreen.pageTitle
        : '4. Authorization for this request',
    },
    {
      description: langStrings
        ? langStrings.cm.authorizationRequestScreen.confirmLabel
        : 'Please confirm that you are authorized to make this request',
      style: { fontWeight: 'bold' },
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      isCheckbox: true,
      handleChange: (e) => {
        log.debug('e value : ', e)
        if (e) {
          log.debug('Page 4 : Authorize Request value now : ', e)
          dispatch({
            type: 'MAKE_CM_AUTHORIZED',
            payload: e,
          })
        } else {
          log.debug('Page 4 : Authorize Request value now : ', e)
          dispatch({
            type: 'MAKE_CM_AUTHORIZED',
            payload: false,
          })
        }
      },
      isChecked: authorized,
      label: 'ChangeCM',
      disabled: false,
      paragraphStyle: { display: 'inline-flex', width: '16px' },
    },
    {
      description: langStrings
        ? langStrings.cm.authorizationRequestScreen.option1
        : 'I confirm that I am the contract manager or have been given the appropriate authority' +
          'from the company that owns this subscription to make this request.',
      style: { fontSize: '14px' },
      paragraphStyle: { marginTop: '-15px', marginLeft: '20px' },
    },
  ]
}

const configFooter = ({
  state: {
    credentials,
    langStrings,
    hasExtension,
    userSession,
    newCmDetails,
    currentCMDetails,
    authorized,
  },
  dispatch,
}) => ({
  requiredDisclaimer: true,
  hasQuestion: true,
  hasExtension,
  nextButtonContent: langStrings ? langStrings.buttons.submitButton : 'SUBMIT',
  handleBack: () => {
    pushGTMEvent('NewInfo')
    dispatch({ type: 'GO_TO_NEW_CM_PAGE' })
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) =>
    dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleChatInitialized: () => dispatch({ type: 'AGENT_INITIALIZED' }),
  handleChatStarted: () => dispatch({ type: 'GO_TO_AGENT_AVAILABLE_PAGE' }),
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-next-button',
  handleBackButtonId: 'adsktm-cm-back-button',
  requiredDisclaimerId: 'adsktm-required-disclaimer-text',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
  // eslint-disable-next-line no-unneeded-ternary
  enableNextButton: authorized,
  handleNext: async () =>
    await asynCMCall(
      dispatch,
      userSession,
      newCmDetails,
      currentCMDetails,
      credentials,
    ),
})

export default {
  configContents,
  configFooter,
}
